<!-- APP HEADER -->
<app-header
  [hidePortal]="hidePortalMenu"
  [showLanguageToggler]="showLanguageToggler"
  [currentLanguage]="currentLanguage"
  [showHoaLogo]="isHoADocs"
  (languageChange)="toggleLanguage($event)"
  >
</app-header>
<!-- ALL THE TEXT -->
@if (imageData$ | async; as imageData) {
  <div
    class="section-wrapper"
    [class.big-text]="bigText"
    [ngClass]="imageData.classes"
    [ngClass]="{ hoaContainer: isHoADocs }"
    >
    <h1>@if (icon) {
      <fa-icon [icon]="icon"></fa-icon>
    }{{ title }}</h1>
    <section class="section-content"><ng-content></ng-content></section>
    @if (!isMobile) {
      <div class="section-buttons">
        @if (primaryButton) {
          <page-button
            [config]="{ label: primaryButton, hoaButton: isHoADocs ? 'hoaButton' : '' }"
            (clicked)="primaryClicked()"
          ></page-button>
        }
        @if (secondaryButton) {
          <page-button
            [config]="{ label: secondaryButton, rank: 'secondary' }"
            (clicked)="secondaryClicked()"
          ></page-button>
        }
      </div>
    }
    <ng-content select="[secondary-content]"></ng-content>
  </div>
  <!-- BACKGROUND-IMAGE -->
  <div class="background" [ngClass]="imageData.classes">
    <div class="background-overlay"></div>
    @if (showImage) {
      <div class="background-image" [preloadImage]="imageData.imageUrl"></div>
    }
  </div>
}

<!-- MOBILE FOOTER -->
@if (primaryButton && isMobile) {
  <div class="footer-wrapper">
    <footer-mobile
      [valid]="true"
    [primary]="{
      label: primaryButton,
      arrow: showRightArrow,
      hoaButton: isHoADocs ? 'hoaButton' : ''
    }"
      (primaryClicked)="primaryClicked()"
      [secondary]="{ label: secondaryButton, arrow: showLeftArrow }"
      (secondaryClicked)="secondaryClicked()"
    ></footer-mobile>
  </div>
}
